import { createFileRoute } from '@tanstack/react-router'
import { useOrganization } from '@/pages/organizations/detail'
import OrganizationSetsPageContent from '@/pages/organizations/detail/sets/_components/OrganizationSetsPageContent'

export const Route = createFileRoute('/app/organizations/$organizationId/sets/')({
  component: RouteComponent,
})

function RouteComponent() {
  const {
    organization,
    userCanEditAssessments,
    userCanViewAssessments,
    assessments,
    assessmentsLoading,
    responses,
  } = useOrganization()

  return (
    <OrganizationSetsPageContent
      organization={organization}
      userCanEditAssessments={userCanEditAssessments}
      userCanViewAssessments={userCanViewAssessments}
      assessments={assessments}
      assessmentsLoading={assessmentsLoading}
      responses={responses}
    />
  )
}
